import React, { useEffect, useState } from "react"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { jnstyls } from '~/utils/helpers'

import * as styles from "~/styles/shared/callouts.module.scss"

const Callouts = ({ callout_arr, wr_class, gaInteract=false }) => {
  const { gender } = useTheme()

  const [didLoad, setDidLoad] = useState(false)

  const handleClick = () => {
    if (gaInteract) gaInteract('tile click: callout')
  }
  
  const g_switches = ['New Arrival', 'Coming Soon', 'Best Seller']

  const checkGendColl = (name, url) => {
    if (!didLoad) return url
    if (!g_switches.includes(name)) return url

    let path = '/collections/'
    if (name === 'New Arrival') {
      path += (gender === 'men') ? 'mens-new-arrivals' : 'womens-new-arrivals'
    }
    if (name === 'Coming Soon') {
      path += (gender === 'men') ? 'mens-coming-soon' : 'womens-coming-soon'
    }
    if (name === 'Best Seller') {
      path += (gender === 'men') ? 'best-sellers' : 'womens-best-sellers'
    }

    return path
  }

  useEffect(() => {
    setDidLoad(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])


  return (
    <div className={jnstyls([wr_class, styles.callouts, styles.callouts])}>
      {callout_arr.map( (callout, index) => {
        return (
          <React.Fragment key={`callout_${index}`}>
            {callout.link ? (
              <Flink 
                href={checkGendColl(callout.name, callout.link)} 
                className={jnstyls([styles.callout, styles.callout_link])}
                style={{color: `${callout.color ? callout.color : ''}`}}
                onClick={(e) => handleClick()}
              >
                {callout.name}
              </Flink>
            ) : (
              <span 
                className={styles.callout} 
                style={{color: `${callout.color ? callout.color : ''}`}}
                >
                {callout.name}
              </span>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Callouts






